import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { gaWidgetDataAutomation } from "app/pages/activation/components/GAWidget/dataAutomationKeys";

import { useActivationGaMappingDetailQuery } from "./hooks";
import { GaConnectTexts } from "./texts";

export type GAConnectedPropertyInfoSchema = {
    activationId: string;
};

export const GAConnectedPropertyInfo = ({ activationId }: GAConnectedPropertyInfoSchema) => {
    const { translate } = useTranslate();
    const { data, isLoading } = useActivationGaMappingDetailQuery(activationId);

    if (!data || data.state === "Faulty" || isLoading) {
        return null;
    }

    const { analyticsAccountName, connectionName, propertyName } = data;

    return (
        <Flex
            data-automation={gaWidgetDataAutomation.connectionDataBadge}
            gap="8px"
        >
            <SWReactIcons
                iconName="ga-icon"
                size="xs"
            />
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[250]}
                data-automation={gaWidgetDataAutomation.connectionDataText}
            >
                {translate(GaConnectTexts.gaConnectedPropertyInfo, { propertyName })}
            </Text>
            <Tooltip
                content={
                    <Trans
                        i18nKey={GaConnectTexts.gaConnectedPropertyTooltip}
                        values={{ connectionName, accountName: analyticsAccountName, propertyName }}
                        t={translate}
                    />
                }
            >
                <SWReactIcons
                    iconName="info"
                    size="xs"
                />
            </Tooltip>
        </Flex>
    );
};
